import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import {
  getVisaApplication_action,
  deleteVisaApplication_action,
  submitVisaApplication_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/invitationVisaApplication_action/visaApplication_action";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";

class InvitationVisaApplicationList extends Component {
  // Initialize Constructor
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      visaApplicationList: [],
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),
      isDelOpen: false,
      VisaApplicationFormID: "",
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      is_View: false,
    };
    this.getVisaApplicationList = this.getVisaApplicationList.bind(this);
    this.deleteVisaApplication = this.deleteVisaApplication.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.onUpdateClick = this.onUpdateClick.bind(this);
    this.toggleDelModal = this.toggleDelModal.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.submitVisaApplications = this.submitVisaApplications.bind(this);
    this.onViewClick = this.onViewClick.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.submitVisaApplications()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });
    this.getVisaApplicationList();
  }

  // Get visa application list
  getVisaApplicationList() {
    this.setState({ isLoading: true });
    this.props
      .getVisaApplication_action()
      .then((data) => {
        if (data.error != 1) {
          console.log("Visa application list", data.data);
          this.setState({ visaApplicationList: data.data, isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //Visa application
  deleteVisaApplication() {
    this.setState({ isLoading: true });
    this.props
      .deleteVisaApplication_action()
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Record deleted successfully");
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Handle Add
  handleAdd() {
    const { DeadlineDate } = this.state;
    this.props.navigate("/visaApplicationAU", {
      state: {
        is_add: true,
        Deadline: DeadlineDate,
        StatusID: null,
      },
    });
  }

  // On Update Icon Click
  onUpdateClick(Id) {
    const { DeadlineDate } = this.state;
    this.props.navigate("/visaApplicationAU", {
      state: {
        is_update: true,
        VisaApplicationFormID: Id,
        Deadline: DeadlineDate,
        StatusID:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.StatusID != null
            ? this.props.location.state.StatusID
            : false,
      },
    });
  }

  // On View Click
  onViewClick(Id) {
    const { DeadlineDate } = this.state;
    this.props.navigate("/visaApplicationAU", {
      state: {
        is_View: true,
        VisaApplicationFormID: Id,
        Deadline: DeadlineDate,
        StatusID:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.StatusID != null
            ? this.props.location.state.StatusID
            : false,
      },
    });
  }

  // Handle Back
  handleBack() {
    window.history.back();
  }

  //toggle for delete
  toggleDelModal(id) {
    const { isDelOpen } = this.state;
    this.setState({
      isDelOpen: !isDelOpen,
      VisaApplicationFormID: id,
    });
  }

  // // handle Receipt Delete"
  handleDelete(e) {
    e.preventDefault();
    const { isDelOpen, VisaApplicationFormID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .deleteVisaApplication_action(VisaApplicationFormID)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Visa Application Deleted SuccessFully");
          this.setState({ isLoading: false, isDelOpen: !isDelOpen });
          this.getVisaApplicationList();
        } else {
          toastError(data.msg);
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // On submit Visa Application
  submitVisaApplications() {
    this.setState({ isLoading: true });
    this.props
      .submitVisaApplication_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          window.history.back();
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    const {
      isLoading,
      isDelOpen,
      visaApplicationList,
      currentDate,
      DeadlineDate,
      StatusID,
      isHideSection, isOpenConfirmationModal
    } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(
        moment(DeadlineDate, "DD-MM-YYYY")
      );
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className="page">
          <div className="page-main">
            <div className={!isHideSection ? "with-dr-container" : ""}>
              {!isHideSection && (
                <div className=" width-dr-nav">
                  <div className="row mt-4">
                    <ExhibitorTopMenu />
                  </div>
                </div>
              )}
              <div className="row mt-5 mt-md-4 m-0">
                <div className="col-xl-12">
                  <div className="card rounded-0 p-0 border">
                    <div className="card-header p-2">
                      <h3 className="card-title">
                        Invitation letter for visa Application
                      </h3>
                    </div>
                    <div className="card-body p-2">
                      <div className="row">
                        {isDeadlinePassed && (
                          <span className="text-danger">
                            THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                          </span>
                        )}
                      </div>
                      <div className="row">
                        <p className="text-danger m-0">
                          (Please note that the visa invitation letter will be issued only after the registration is confirmed and 100% payment has been received.)
                        </p>
                      </div>
                      {!isHideSection && (
                        <>
                          <button
                            className="btn btn-aqua mr-2"
                            type="btn"
                            style={{ float: "right", width: "60px" }}
                            disabled={isDeadlinePassed}
                            onClick={(e) => this.handleAdd()}
                          >
                            Add
                          </button>
                        </>
                      )}
                      <div className="table-responsive mt-6">
                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                          <thead>
                            <tr>
                              <th>First Name</th>
                              <th>Middel Name</th>
                              <th>Last Name</th>
                              <th>Email</th>
                              <th>Country</th>
                              <th>Mobile</th>
                              {/* <th>ID Type</th> */}
                              <th>Passport No</th>
                              <th>Status</th>
                              <th
                                style={{ width: "60px" }}
                                className="text-center"
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {visaApplicationList.length > 0 ? (
                              visaApplicationList.map((data) => (
                                <tr key={data.VisaApplicationFormID}>
                                  <td>{data.FirstName}</td>
                                  <td>{data.MiddleName || '-'}</td>
                                  <td>{data.LastName}</td>
                                  <td>{data.Email}</td>
                                  <td>{data.CountryName}</td>
                                  <td>{data.MobileNo}</td>
                                  {/* <td>{data.IDType}</td> */}
                                  <td>{data.PassportNo}</td>
                                  <td className="text-center">{data.Status}</td>
                                  <td className="text-center">
                                    {currentDate < DeadlineDate && (
                                      <span className="action-icon">
                                        {data.Status != "Approved" ? (
                                          <i
                                            className="fa fa-trash text-danger"
                                            aria-hidden="true"
                                            onClick={(e) =>
                                              this.toggleDelModal(
                                                data.VisaApplicationFormID
                                              )
                                            }
                                          />
                                        ) : (
                                          <></>
                                        )}
                                      </span>
                                    )}
                                    <span className="">
                                      {data.Status == "Approved" ||
                                        isDeadlinePassed ? (
                                        <i
                                          className="fa fa-eye text-info"
                                          aria-hidden="true"
                                          onClick={(e) =>
                                            this.onViewClick(
                                              data.VisaApplicationFormID
                                            )
                                          }
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-pencil text-info"
                                          aria-hidden="true"
                                          onClick={(e) =>
                                            this.onUpdateClick(
                                              data.VisaApplicationFormID
                                            )
                                          }
                                        />
                                      )}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td className="text-center" colSpan={15}>
                                  No record found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                      </div>

                      <div className="d-flex justify-content-end mt-0">
                        {/* {!isHideSection && (
                          <button
                            type="button"
                            className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                            style={{ marginRight: 10 }}
                            disabled={isDeadlinePassed}
                            // onClick={() => this.submitVisaApplications()}
                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                          >
                            Submit
                          </button>
                        )} */}
                        <button
                          type="button"
                          className="btn rounded-1 mt-3 mb-3 btn-gray"
                          // style={{ float: "right", width: "60px" }}
                          onClick={(e) => this.handleBack()}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={isDelOpen}
          onRequestClose={() => this.setState({ isDelOpen: false })}
        >
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header p-2">
                <h5 class="modal-title">
                  Confirm Delete
                </h5>
                <button
                  type="button "
                  class="close pop-close"
                  data-dismiss="modal"
                  onClick={() => this.setState({ isDelOpen: false })}
                >
                  <span aria-hidden="true" class="pop-cancel">
                    &times;
                  </span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <p class="pop_label">
                      Do you really want to delete this record?
                    </p>
                  </div>
                </div>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-del-pop"
                    onClick={(e) => this.handleDelete(e)}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ isDelOpen: false })}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getVisaApplication_action,
    deleteVisaApplication_action,
    submitVisaApplication_action,
  })(InvitationVisaApplicationList)
);
